import { Badge } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { WorkingTimeImportStatus } from "@/orval/gen"
import { getWorkingTimeImportStatusColor } from "./getWorkingTimeImportStatusColor"

export function WorkingTimeImportStatusBadge({
  status,
}: {
  status: WorkingTimeImportStatus
}) {
  const { t } = useTranslation("app_server")
  const color = getWorkingTimeImportStatusColor(status)

  return <Badge color={color}>{t(`WorkingTimeImportStatus_${status}`)}</Badge>
}
